import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core';

import { disabledProviderFactory, WithDisabled } from '../../helpers';
import { ButtonSize, ComponentStyle } from '../../models';

enum ButtonType {
  Default = 'button',
  Submit = 'submit'
}

enum ButtonIconPosition {
  Default = 'left',
  Right = 'right'
}

@Component({
  selector: 'pcs-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  providers: [
    disabledProviderFactory(ButtonComponent)
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ButtonComponent implements WithDisabled, OnChanges {

  @HostBinding('class.disabled')
  @Input() disabled = false;
  @Input() buttonId = '';
  @Input() icon;
  @Input() buttonText = '';
  @Input() type = ButtonType.Default;
  @Input() buttonStyle = ComponentStyle.Default;
  @Input() buttonSize = ButtonSize.Default;
  @Input() buttonIconPosition = ButtonIconPosition.Default;
  @Input() tabIndex;
  @Input() title = '';
  @Input() iconStyles = '';

  @Output() clicked = new EventEmitter();

  buttonClasses = null;

  ngOnChanges(changes: SimpleChanges): void {
    this.buttonClasses = this.calculateButtonClasses();
  }

  onClick($event) {
    if (!this.disabled) {
      this.clicked.emit($event);
    }
  }

  private calculateButtonClasses() {
    return {
      'btn-basic': this.isOfStyle(ComponentStyle.Default),
      'btn-primary': this.isOfStyle(ComponentStyle.Primary),
      'btn-secondary': this.isOfStyle(ComponentStyle.Secondary),
      'btn-success': this.isOfStyle(ComponentStyle.Success),
      'btn-info': this.isOfStyle(ComponentStyle.Info),
      'btn-warning': this.isOfStyle(ComponentStyle.Warning),
      'btn-danger': this.isOfStyle(ComponentStyle.Danger),
      'btn-link': this.isOfStyle(ComponentStyle.Link),
      'btn-icon-danger': this.isOfStyle(ComponentStyle.IconDanger),
      'btn-sm': this.isOfSize(ButtonSize.Small),
      'btn-lg': this.isOfSize(ButtonSize.Large),
      'btn-icon-right': this.isIconRight(),
      'btn-link-icon': !this.buttonText && this.icon
    };
  }

  private isOfStyle(style: ComponentStyle) {
    return this.buttonStyle === style;
  }

  private isOfSize(size: ButtonSize) {
    return this.buttonSize === size;
  }

  private isIconRight() {
    return this.buttonIconPosition === ButtonIconPosition.Right;
  }
}
